import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Form, InputGroup, Modal, Row } from 'react-bootstrap';
import { useForm } from '../../hooks/useForm';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import { fetchConToken } from '../../api/fetch';
import { useContextInfo } from '../../context/ContextInfo';
import { RedContext } from '../../context/connection/ContextRed';
const initialState = {
    id: '',
    id_mk:'',
    nombre: '',
    ip: '',
    modelo: 'Vsol-V1600G0',
    version: '1.X',
    tipo_pon: 'EPON',
    port_ssh: 22,
    port_telnet: 23,
    port_snmp: 161,
    com_read: '',
    com_rw: '',
    usuario: '',
    pass: '',
};
const EditOltM = ({ show, onHide, dialogClassName, size, scrollable, olt, callBk }) => {
    const [validated, setValidated] = useState(false);
    const [type, setType] = useState('password');
    const { redState } = useContext(RedContext);

    const { setResp } = useContextInfo();

    const [values, handleInputChange, reset, setFormValue] = useForm({ ...initialState });
    const { id } = values;
    useEffect(() => {
        !show ? setFormValue({ ...initialState }) : setFormValue({ ...values, ...olt });
    }, [show]);
    const funClose = () => {
        if (id) {
            onHide();
        } else {
            reset();
            onHide();
        }
    };
    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            const res = await fetchConToken('fibra/olt', { ...values }, 'POST');
            setResp(res);
            callBk();
            reset();
            funClose();
        }
    };
    return (
        <Modal show={show} onHide={funClose} dialogClassName={dialogClassName} size={size} scrollable={scrollable}>
            <Modal.Header onHide={funClose} closeButton>
                <h4 className="modal-title">{id ? 'Editar OLT' : 'Nueva OLT'}</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                        <Row>
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom01">
                                                    <Form.Label>Nombre</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        placeholder="Nombre olt"
                                                        value={values.nombre}
                                                        name="nombre"
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                                </Form.Group>{' '}
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom02">
                                                    <Form.Label>Ip</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        placeholder="Ip"
                                                        value={values.ip}
                                                        name="ip"
                                                        onChange={handleInputChange}
                                                    />
                                                </Form.Group>
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>{' '}
                                            </Col>
                                            <Form.Group className="mb-3" controlId="validationCustom022">
                                            <Form.Label>Router</Form.Label>
                                            <Form.Select
                                                value={values.id_mk}
                                                name="id_mk"
                                                required
                                                onChange={handleInputChange}>
                                                <option value={''} disabled selected>
                                                    Seleccionar...
                                                </option>
                                                {redState.mktiks.map((mk, i) => (
                                                    <option value={mk.id} key={i}>
                                                        {mk.nodo}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom022">
                                                    <Form.Label>Modelo</Form.Label>
                                                    <Form.Select
                                                        value={values.modelo}
                                                        name="modelo"
                                                        required
                                                        onChange={handleInputChange}>
                                                        <option value="Vsol-V1600G0">Vsol-V1600G0</option>
                                                        <option value="Vsol-V1600G1">Vsol-V1600G1</option>
                                                        <option value="Vsol-V1600G2">Vsol-V1600G2</option>
                                                        <option value="VsoL-v1600D2">VsoL-v1600D2</option>
                                                        <option value="VsoL-v1600D-MINI">VsoL-v1600D-MINI</option>
                                                        <option value="VsoL-v1600D2-L">VsoL-v1600D2-L</option>
                                                        <option value="VsoL-v1600D4">VsoL-v1600D4</option>
                                                        <option value="VsoL-v1600D4-L">VsoL-v1600D4-L</option>
                                                        <option value="VsoL-v1600D4-DP">VsoL-v1600D4-DP</option>
                                                        <option value="VsoL-v1600D8">VsoL-v1600D8</option>
                                                        <option value="VsoL-v1600D16">VsoL-v1600D16</option>
                                                        <option value="TP-LINK">TP-LINK</option>
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>{' '}
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom003">
                                                    <Form.Label>Version</Form.Label>
                                                    <Form.Select
                                                        value={values.version}
                                                        name="version"
                                                        required
                                                        onChange={handleInputChange}>
                                                        <option value="1.X">1.X</option>
                                                        <option value="2.X">2.X</option>
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>{' '}
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom004">
                                                    <Form.Label>Tipo pon</Form.Label>
                                                    <Form.Select
                                                        value={values.tipo_pon}
                                                        name="tipo_pon"
                                                        required
                                                        onChange={handleInputChange}>
                                                        <option value="EPON">EPON</option>
                                                        <option value="GPON">GPON</option>
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Control.Feedback>Válido</Form.Control.Feedback>{' '}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustomUsername">
                                                    <Form.Label>Puerto SSH</Form.Label>

                                                    <Form.Control
                                                        type="number"
                                                        value={values.port_ssh}
                                                        name="port_ssh"
                                                        required
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Introduce un puerto valido
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom03">
                                                    <Form.Label>Puerto telnet</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={values.port_telnet}
                                                        name="port_telnet"
                                                        required
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Introduce un puerto valido{' '}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom04">
                                                    <Form.Label>Puerto SNMP</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={values.port_snmp}
                                                        name="port_snmp"
                                                        required
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Introduce un puerto valido
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom05">
                                                    <Form.Label>Comunidad SNMP de lectura</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={values.com_read}
                                                        name="com_read"
                                                        required
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Ingrese una comunidad
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom06">
                                                    <Form.Label>Comunidad SNMP de lectura y escritura</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={values.com_rw}
                                                        name="com_rw"
                                                        required
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Ingrese una comunidad
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom07">
                                                    <Form.Label>Usuario</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="usuario"
                                                        required
                                                        value={values.usuario}
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Ingrese un usuario
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="validationCustom08">
                                                    <Form.Label>Contraseña</Form.Label>
                                                    <InputGroup hasValidation>
                                                        <InputGroup.Text id="inputGroupPrepend">
                                                            {type === 'password' ? (
                                                                <AiFillEye onClick={() => setType('text')} />
                                                            ) : (
                                                                <AiFillEyeInvisible
                                                                    onClick={() => setType('password')}
                                                                />
                                                            )}
                                                        </InputGroup.Text>
                                                        <Form.Control
                                                            type={type}
                                                            name="pass"
                                                            value={values.pass}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            Ingrese una Contraseña
                                                        </Form.Control.Feedback>{' '}
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Button type="submit">Guardar</Button>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};
export default EditOltM;
